import {Grid, Typography } from '@mui/material';
import {
    Outlet
  } from 'react-router-dom';

const CTSManagement = () => {
    return (
        <Grid >
            <Typography variant="h5" component="h2">
                Manage CTS Code
            </Typography>
            <Outlet />
        </Grid> 
    )
}

export default CTSManagement;